import pkg from '../../../../package.json';

export const { dependencies, version } = pkg;
